import { render } from "./wPaymentType.vue?vue&type=template&id=17a2de95&ts=true"
import script from "./wPaymentType.vue?vue&type=script&lang=ts"
export * from "./wPaymentType.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__